import { render, staticRenderFns } from "./ResourceType.vue?vue&type=template&id=dbc45c5c"
import script from "./ResourceType.vue?vue&type=script&lang=js"
export * from "./ResourceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbc45c5c')) {
      api.createRecord('dbc45c5c', component.options)
    } else {
      api.reload('dbc45c5c', component.options)
    }
    module.hot.accept("./ResourceType.vue?vue&type=template&id=dbc45c5c", function () {
      api.rerender('dbc45c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/ResourceType.vue"
export default component.exports